import { paths } from 'src/routes/paths';

export const { VITE_MOTOR_API_URL: MOTOR_API_URL } = import.meta.env;
export const { VITE_APP_API_URL: APP_API_URL } = import.meta.env;
export const { VITE_AUTH_GATEWAY_URL: AUTH_GATEWAY_URL } = import.meta.env;

export const { VITE_ASSETS_API_URL: ASSETS_API_URL } = import.meta.env;
export const { VITE_SENTRY_DSN: SENTRY_DSN } = import.meta.env;

export const PATH_AFTER_LOGIN = paths.root;
export const PATH_AFTER_LOGOUT = paths.auth.login;
